import React, { useEffect } from 'react';
import TechnologiesSection from '../components/TechnologiesSection';
import CtaSection from '../components/CtaSection';
import { useLanguage } from '../contexts/LanguageContext';

const TechnologiesPage: React.FC = () => {
  const { language, translations } = useLanguage();

  useEffect(() => {
    // Set dynamic page title based on language
    let pageTitle = 'Technologien - SeaDent Mallorca';
    if (language === 'en') {
      pageTitle = 'Technologies - SeaDent Mallorca';
    } else if (language === 'es') {
      pageTitle = 'Tecnologías - SeaDent Mallorca';
    } else if (language === 'ru') {
      pageTitle = 'Технологии - SeaDent Майорка';
    }

    document.title = pageTitle;

    // Set meta description based on language
    let metaContent = 'Modernste Technologien für Ihre Zahnbehandlung: DVT, Intraoralscanner und Dentallaser. Schmerzfrei und komfortabel bei SeaDent Mallorca.';
    if (language === 'en') {
      metaContent = 'State-of-the-art technologies for your dental treatment: DVT, intraoral scanner, and dental laser. Pain-free and comfortable at SeaDent Mallorca.';
    } else if (language === 'es') {
      metaContent = 'Tecnologías de vanguardia para su tratamiento dental: DVT, escáner intraoral y láser dental. Sin dolor y cómodo en SeaDent Mallorca.';
    } else if (language === 'ru') {
      metaContent = 'Передовые технологии для вашего стоматологического лечения: КТ, интраоральный сканер и стоматологический лазер. Безболезненно и комфортно в SeaDent Майорка.';
    }

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaContent);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = metaContent;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, [language]);

  return (
    <main className="pt-20 lg:pt-32">
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.technologies.title}</h1>
          <p className="text-xl">{translations.technologies.intro}</p>
        </div>
      </div>
      <TechnologiesSection />
      <CtaSection />
    </main>
  );
};

export default TechnologiesPage; 